<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Estoque</app-titulo>
      <div class="header-buttons">
        <app-botao type="primario" class="button" text="Nova Entrada" icon="assets/add.svg"
          (click)="navegarEntrada()"></app-botao>
        <app-botao type="secundario" class="button" text="Nova Saída" icon="assets/add.svg"
          (click)="navegarSaida()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar PDF" icon="assets/exportar-excel.svg"
          (click)="exportarPdf()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Saldo em Estoque</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input label="Produto" name="NM_PROD" formControlName="NM_PROD" width="100%"></app-input>
            <div>
              <label>Somente em estoque</label>
              <label class="switch">
                <input type="checkbox" [checked]="form.controls.FL_EM_ESTQ.value"
                  (change)="toggleEmEstoque($any($event.target).checked)">
                <span class="slider"></span>
              </label>
            </div>
            <div>
              <label>Somente estoque baixo</label>
              <label class="switch">
                <input type="checkbox" [checked]="form.controls.FL_ESTQ_BX.value"
                  (change)="toggleEstoqueBaixo($any($event.target).checked)">
                <span class="slider"></span>
              </label>
            </div>
          </form>
        </div>
      </div>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
      <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">Valor Total em Estoque: {{ valorTotalFormatado }}</h2>
      </div>
      <div class="paginacao">
        <app-paginacao *ngIf="maxPages > 1" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
      </div>
    </div>
  </div>
  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
